// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"d77f8582","256":"c4309ee9","457":"a29a1bee","551":"c3827936","617":"7d129983","621":"bdfe9be9","851":"8beae88b"}[chunkId] + ".chunk.js";
};